import axios from 'axios';
import { CreateOrderModel } from '../../models/order-model';

const API_URL = 'https://cava-don-carlos.herokuapp.com/api/v1/';

const createOrder = (order: CreateOrderModel) => {
    return axios.post(`${API_URL}orders`, order);
}

const getOrders = (page: number, limit: number, statusFilter: string[]) => {
    return axios.post(`${API_URL}orders/myOrders?page=${page}&limit=${limit}`, { statusFilter });
}

const getOrderDetail = (id: string) => {
    return axios.get(`${API_URL}orders/${id}`);
}

const updateOrder = (id: string, payload: any) => {
    return axios.put(`${API_URL}orders/${id}`, payload)
}

export const API = {
    createOrder,
    getOrders,
    getOrderDetail,
    updateOrder
}